import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import moment from "moment-jalaali";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import Select from "./Select/Select";
import CInput from "../../Components/UI/CInput/CInput";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
import useAsync from "../../hooks/asyncRequests";
import Header from "../../Components/UI/Header/Header";
import Footer from "../../Components/UI/Footer/Footer";
import Icon from "@mdi/react";
import { mdiCloudUploadOutline } from "@mdi/js";
import masarefKeshavarziImg from "../../assets/Charts/masaref-keshavarzi.png";
import masarefShorbImg from "../../assets/Charts/masaref-shorb.png";
import masarefSanatImg from "../../assets/Charts/masaref-sanat.png";
import rahasaziLakeImg from "../../assets/Charts/rahasazi-daryache.png";
// import totalInputImg from "../../assets/Charts/total-input.png";
// import percentFillImg from "../../assets/Charts/percent-fill.png";
import volumeInputImg from "../../assets/Charts/volume_input.png";
import { Helmet } from "react-helmet";

const WareHouseDict = {
  farming_usage: "مجموع کشاورزی",
  drinking_usage: "مجموع شرب",
  industrial_usage: "مجموع صنعت",
  other: "مجموع دریاچه",
  volume: "مجموع حجم",
};
const thisPageData = {
  options: [
    {
      value: "مجموع کشاورزی",
      gainValue: "farming_usage",
      unit: "MCM",
      color: "174, 213, 129",
      img: masarefKeshavarziImg,
    },
    {
      value: "مجموع شرب",
      gainValue: "drinking_usage",
      unit: "MCM",
      color: "144, 202, 249",
      img: masarefShorbImg,
    },
    {
      value: "مجموع صنعت",
      gainValue: "industrial_usage",
      unit: "MCM",
      color: "188, 170, 164",
      img: masarefSanatImg,
    },
    {
      value: "مجموع دریاچه",
      gainValue: "other",
      unit: "MCM",
      color: "21, 101, 192",
      img: rahasaziLakeImg,
    },
    {
      value: "مجموع حجم",
      gainValue: "volume",
      unit: "MCM",
      color: "207, 216, 220",
      img: volumeInputImg,
    },
  ],
  title: "مخزن",
};

const ChartPages = () => {
  const [chartData, setChartData] = useState({});
  const [value, setValue] = useState(
    thisPageData.options[thisPageData.options.length - 1].gainValue
  );
  // const [Range, setRange] = useState(1);

  const token = useSelector((state) => state.auth.Token);
  const { isLoadingAsync, finalData, clearAsync, Key } = useAsync({
    Key: 1,
    reqData: {
      chart: {
        url: `dam-total-usage/`,
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
    },
  });

  const [AllChartData, setAllChartData] = useState({});
  const [Color, setColor] = useState("#9fa8da");
  const [Last, setLast] = useState();
  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());
  const [isLoading, setIsLoading] = useState();

  const chartRef = useRef(null);

  useEffect(() => {
    const colors = {};
    thisPageData.options.forEach((element) => {
      colors[element.gainValue] = element.color;
    });
    setColor(colors);

    console.log(colors);
  }, [setColor]);

  useEffect(() => {
    console.log(Color);
  }, [Color]);

  useEffect(() => {
    console.log(finalData);
    if (!finalData || !Key || Key === "loading") {
      return;
    }

    if (AllChartData[Key]) {
      return;
    }

    const { chart } = finalData;

    if (chart && !chart.error && chart.real.length > 0) {
      const allChartData = { labels: [] };
      const allOptions = thisPageData.options;

      allOptions.forEach((e) => {
        allChartData[e.gainValue] = [];
        return 0;
      });

      let date;
      chart.real.forEach((CD) => {
        date = moment(CD.date).format("jYYYY-jMM-jDD");
        allChartData.labels.push(date);
        allOptions.forEach((e) => {
          allChartData[e.gainValue].push({ y: CD[e.gainValue], x: date });
        });
      });

      const reversed = {};

      for (const key in allChartData) {
        reversed[key] = allChartData[key].reverse();
      }

      console.log(reversed);
      setAllChartData((pre) => {
        const p = { ...pre };
        p[Key] = reversed;
        return p;
      });

      setLast(chart.latest);

      setChartData({
        data: {
          datasets: [
            {
              pointHoverRadius: 5,
              pointHitRadius: 30,
              tension: 0.4,
              fill: false,
              cubicInterpolationMode: "monotone",
              parsing: false,
            },
          ],
        },
        options: {
          animation: false,
          normalized: true,
          spanGaps: true,
          // showLine: false,
          datasets: {
            line: {
              pointRadius: 0, // disable for all `'line'` datasets
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            yAxes: {
              title: {
                display: true,
                // text: 'yAxisTitle',
                font: {
                  size: 15,
                },
              },
            },
            xAxes: {
              title: {
                display: true,
                text: "تاریخ",
                font: {
                  size: 15,
                  family: "IRANSansWeb",
                  weight: "bold",
                },
              },
            },
          },
        },
      });
    }

    clearAsync();
  }, [finalData, setAllChartData, setChartData, clearAsync, AllChartData, Key]);

  useEffect(() => console.log(AllChartData), [AllChartData]);
  useEffect(() => console.log(Key), [Key]);

  // const download = useCallback(() => {
  //   fetch(chartRef.current.toBase64Image(), {
  //     method: 'GET',
  //     headers: {},
  //   })
  //     .then((response) => {
  //       response.arrayBuffer().then(function (buffer) {
  //         const url = window.URL.createObjectURL(new Blob([buffer]));
  //         const link = document.createElement('a');
  //         link.href = url;
  //         link.setAttribute('download', `${value}.png`);
  //         document.body.appendChild(link);
  //         link.click();
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [chartRef, value]);

  const chart = useMemo(() => {
    // if (chartData) {
    //   let dt = null;
    //   if (chartData.data && chartData.data.datasets[0].data) {
    //     dt = chartData;
    //   }

    return <Line ref={chartRef} {...chartData} />;
    // }
  }, [chartData, chartRef]);

  useEffect(() => {
    if (value) {
      setChartData(
        (pre) =>
          pre &&
          Object.keys(pre).length && {
            ...pre,
            data: {
              labels: AllChartData[1].labels,
              datasets: [
                {
                  ...pre.data.datasets[0],
                  label: value,
                  data: AllChartData[1][value],
                  // backgroundColor: `rgba(${Color[value]}, 0.4)`,
                  backgroundColor: `rgb(${Color[value]})`,
                  borderColor: `rgb(${Color[value]})`,
                },
              ],
            },
            options: {
              ...pre.options,
              scales: {
                ...pre.options.scales,
                yAxes: {
                  title: {
                    ...pre.options.scales.yAxes.title,
                    text: WareHouseDict[value],
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      weight: "bold",
                    },
                  },
                },
              },
            },
          }
      );
    }
  }, [value, setChartData, AllChartData, Color]);

  const navigation = useMemo(
    () => {
      return (
        <div className="center">
          {/* <span onClick={() => setRange((pre) => pre + 1)}>
          <Icon path={mdiPageLast} title='NEXT' size={1} style={{ visibility: !Range ? 'hidden' : 'visible' }} />
        </span>
        <span>{Range}</span>
        <span onClick={() => setRange((pre) => (pre === 1 ? 1 : pre - 1))}>
          <Icon
            path={mdiPageFirst}
            title='PREVIOUS'
            size={1}
            style={{ visibility: Range === 1 ? 'hidden' : 'visible' }}
          />
        </span> */}
        </div>
      );
    },
    [
      // Range, setRange
    ]
  );

  const downloadCSV = useCallback(() => {
    if (Start.format("YYYY-MM-DD") === End.format("YYYY-MM-DD")) {
      return;
    }

    setIsLoading(true);
    fetch(
      `http://213.233.177.17:8022/download/dam_total?start_date=${Start.format(
        "YYYY-MM-DD"
      )}&end_date=${End.format("YYYY-MM-DD")}&dam_item=REL`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        response.headers.forEach((value, name) => {
          console.log(name + ": " + value);
        });

        return response.blob().then((data) => {
          const the = response.headers.get("Content-disposition");
          const thea = the.slice(the.indexOf('"') + 1, the.length - 1);
          console.log(the);
          console.log(thea);

          return {
            blob: data,
            fileName: thea,
          };
        });
      })
      .then(({ blob, fileName }) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = (fileName ? fileName : "matter") + ".csv";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again)
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }, [token, Start, End]);

  const downloadUI = useMemo(() => {
    return (
      <div className="chartDownload">
        <CInput
          config={{
            type: "calendar",
            placeholder: "تاریخ شروع",
          }}
          value={Start}
          direction="rtl"
          changed={setStart}
        />
        <CInput
          config={{
            type: "calendar",
            placeholder: "تاریخ پایان",
          }}
          value={End}
          direction="rtl"
          changed={setEnd}
        />
        <button onClick={downloadCSV}>
          دریافت داده ها به فرمت CSV{" "}
          <Icon path={mdiCloudUploadOutline} size={1} />
        </button>
      </div>
    );
  }, [Start, End, setStart, setEnd, downloadCSV]);

  return (
    <SpinnerHandler isLoading={isLoadingAsync || isLoading}>
      <Helmet>
        <title>نمودار مخازن</title>
      </Helmet>
      <Header />
      <div className="chartInfo">
        <h2>{thisPageData.title}</h2>

        {thisPageData.options && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.options}
            Color={Color[value]}
            last={Last}
          ></Select>
        )}
      </div>

      <div className="center damChart">
        {navigation}
        <div>{chart}</div>
      </div>

      {downloadUI}
      <Footer />
    </SpinnerHandler>
  );
};

export default ChartPages;
